<template>
  <div class="user-rate">
    <div class="page-header">
      <h3 class="page-header_title">
        <slot v-if="isLoaded">{{staticPage.title}}</slot>
        <skeleton-box v-else width="270px" height="33px"></skeleton-box>
      </h3>
    </div>
    <div class="content" style="padding: 20px;">
      <slot v-if="isLoaded">
        <div v-html="staticPage.text"></div>
      </slot>
      <slot v-else>
        <skeleton-box width="100%" height="100px" style="margin-bottom: 20px"></skeleton-box>
        <skeleton-box width="100%" height="100px"></skeleton-box>
      </slot>
    </div>
  </div>
</template>

<script>
    import {USER_RATES_REQUEST} from "../store/actions/userData";
    import {GET_USER_DATA} from "../store/actions/auth";
    import {STATIC_PAGE_REQUEST} from "../store/actions/staticPage";

    import SkeletonBox from "../components/SkeletonBox";

    export default {
        name: "TopUsers",
        components: {SkeletonBox},
        props: ['slug'],
        data() {
            return {
                staticPage: {
                    title: '',
                    text: '',
                    slug: ''
                }
            }
        },
        created() {
            this.staticPage = this.$store.getters.getCurrentStaticPage;

            if (!this.isLoaded) {
                this.$store.dispatch(STATIC_PAGE_REQUEST, this.slug)
                    .catch(err => {
                        this.$router.push({
                            name: 'NotFound'
                        });
                    });
            }
        },
        mounted() {
            this.$store.watch(
                (state, getters) => getters.getCurrentStaticPage,
                (staticPage) => {
                    this.staticPage = staticPage;
                },
            );
        },
        computed: {
            isLoaded() {
                return this.staticPage.title && this.slug === this.staticPage.slug
            }
        }
    }
</script>

<style scoped>

</style>
